import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import SQLogo from '../../img/SelfQueryLogo.png';

const DocumentUnavailable = () => {
  const history = useHistory();

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <img src={SQLogo} style={{ width: '350px', margin: '0 auto' }} alt="SQ Logo" />
      <h1 style={{ textAlign: 'center', color: '#25265d' }}>Documento no disponible</h1>
      <p style={{ textAlign: 'center', color: '#25265d' }}>
        El documento no existe o no tiene permisos para verlo
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button color="primary" variant="contained" onClick={() => history.push('/search')}>
          Volver
        </Button>
      </div>
    </div>
  );
};

export default DocumentUnavailable;
